<template>
  <div class="report_builder">
    <v-container>
      <v-form ref="form" v-model="valid">
        <h2 class="mb-2">
          {{ $store.state.customerName }} CSV読み込みページ 作成画面
        </h2>
        <hr />
        <p>一覧表示する帳票を設定</p>
        <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
        <v-row>
          <v-col cols="12" sm="9">
            <v-card outlined class="pa-6">
              <v-text-field
                v-model="productForms.area[0].list_pageID"
                element="ul"
                label="ページID"
                placeholder="読み込み対象となる帳票のページID"
                background-color="white"
                outlined
                :rules="[rules.numonly]"
                ID
              ></v-text-field>
              <v-row>
                <v-col
                  ><v-radio-group
                    label="csv読み込み形式"
                    v-model="mode"
                    class="ma-2"
                  >
                    <v-radio label="追加" value="add"></v-radio>
                    <v-radio label="差分更新" value="addDiff"></v-radio>
                    <v-radio
                      label="上書き(読み込みデータに無い登録済みデータは削除されます)"
                      value="overWrite"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-btn @click="modalOpen()" color="primary"
                  >CSV読み込み設定</v-btn
                >
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-btn @click="saveForm()" color="primary">SAVE</v-btn>
              </v-row>
              <v-row justify="start">
                <v-btn color="green" @click="productForms.area[0].value = []"
                  >VALUE RESET</v-btn
                >
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-dialog v-if="modal_dialog" v-model="modal_dialog">
          <csv-import
            v-on:clickSubmit="modalClose"
            :value="value_t"
            :rule="addRule"
            :page_id="Number(productForms.area[0].list_pageID)"
          ></csv-import>
        </v-dialog>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import CsvImport from "../../components/BuilderForm/CsvImport/CsvImport";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  components: {
    CsvImport,
  },
  data() {
    return {
      productForms: {
        pageID: null,
        area: [{ type: 13, list_pageID: null, value: [] }],
        delete_area: [],
      },
      //バリデーション
      valid: true,
      rules: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
      },
      value_t: [],
      mode: "add",
      modal_dialog: false,
      addRule: [],
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      //page IDとcustomer IDとform情報を送信
      let data = {};
      data.customerID = this.$store.state.customerID;
      data.pageID = Number(this.$route.params.page_id);
      this.productForms.pageID = this.$route.params.page_id;
      this.$store.state.customerID = Number(this.$route.params.id);
      //API通信
      const response = await api.GetForm(data);
      if (response.data.length > 0) {
        this.productForms.area = this.respose_convert(response.data[0]);
      }
      //読み込み終了
      this.isLoading = false;
    },
    async saveForm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let data = {
        pageID: this.productForms.pageID,
        area: [this.productForms.area],
        mode: this.mode + "," + this.addRule.join(","),
      };

      try {
        data.pageID = await api.RegForm(data, "");
        alert("保存完了");
        this.back();
      } catch (err) {
        alert("送信失敗");
        console.log(err);
      }
    },
    respose_convert: function(data) {
      let area = [];
      data.forEach((value) => {
        let tmp = {};
        tmp.form_id = value.ID;
        tmp.value = JSON.parse(value.Value);
        tmp.type = value.Type;
        tmp.list_pageID = value.Init;
        area.push(tmp);
        //--
        let tmp2 = value.Rule.split(",");
        this.mode = tmp2[0];
        this.addRule = tmp2.length > 1 ? tmp2.slice(1) : [];
        console.log("debug:", this.addRule);
      });
      return area;
    },
    modalOpen() {
      if (this.productForms.area[0].value != "") {
        //参照渡しの回避
        this.value_t = JSON.parse(
          JSON.stringify(this.productForms.area[0].value)
        );
      }
      this.modal_dialog = true;
    },
    modalClose(data) {
      console.log("debug:", data);
      this.productForms.area[0].value = data.value;
      this.addRule = data.rule;
      this.value_t = [];
      this.modal_dialog = false;
    },
    back() {
      history.back();
    },
  },
};
</script>
<style lang="stylus">
.droparea {
  background: #eee;
  min-height: 30em;
  padding: 1em;
}
/* ボタンの横に×ボタンwの表示するための調整 */
.tmp {
  width: 95%;
  padding: 0.2em;
  background-color: white;
}
</style>
